import styles from "./main-app-menu.module.css";
import { usePaths } from "BEDROCK/paths";
import { MenuOption } from "./components";

interface UserContentProps {
  email: string | null;
  didClickOption: () => void;
}

export const ContentUser = (props: UserContentProps) => {
  const { myAccount, navigateTo } = usePaths();
  return (
    <div className={styles.userContent}>
      <MenuOption
        label={"My account"}
        subtitle={props.email ?? "No email"}
        iconName="USER"
        onClick={() => {
          navigateTo(myAccount);
          props.didClickOption();
        }}
      />
    </div>
  );
};
